export default __webpack_public_path__ + "static/media/port.55052244.svg";